import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import { Shadows } from 'builder/styles/shadows'
import { ButtonSize, ButtonTheme, ButtonV2 } from 'builder/components/Button'
import { Z_INDEX } from '../utils'

export const SkipButtonContainer = styled.div`
  position: fixed;
  top: 32px;
  right: 32px;
  z-index: ${Z_INDEX + 2};

  ${Media.Phone`
    top: 20px;
    right: 20px;
  `};
`

export const SkipButton = styled(ButtonV2).attrs({
  size: ButtonSize.small,
  theme: ButtonTheme.ghost,
})`
  ${Shadows.lightWithBorder.low};
  border-radius: 24px;
  padding: 8px 20px;
  background-color: ${Colors.White};
  border: none;

  &:hover {
    ${Shadows.lightWithBorder.mid};
    background-color: ${Colors.White};
  }

  ${Media.Phone`
    padding: 6px 16px;
  `};
`
